import { getResizeHandleElementIndex } from "./dom.js";

//#region src/Splitter/utils/pivot.ts
function determinePivotIndices(groupId, dragHandleId, panelGroupElement) {
	const index = getResizeHandleElementIndex(groupId, dragHandleId, panelGroupElement);
	return index != null ? [index, index + 1] : [-1, -1];
}

//#endregion
export { determinePivotIndices };
//# sourceMappingURL=pivot.js.map